/* eslint-disable linebreak-style */

/**
 * Generează structura implicită pentru o comandă nouă în funcție de produsul curent.
 * Reutilizăm această logică atât în OrdersTable, cât și în alte fluxuri (ex. Expozoare).
 */
export const buildNewOrderTemplate = (currentProduct, currentUser) => {
  if (!currentProduct || !currentProduct.cod || !currentUser?.idFirma?.id) {
    return null;
  }

  const baseOrder = {
    tipProdus: currentProduct.cod,
    idFirma: currentUser.idFirma.id,
    id: 0,
    comandarepers: [],
  };

  if (currentProduct.subTip) {
    baseOrder.subTip = currentProduct.subTip;
  }

  const firma = currentUser.idFirma || {};
  const isComisionar = firma.cfg1 === 'DA';
  const getDiscountComisionar = () => {
    switch (currentProduct.cod) {
    case 'jv':
      return firma.discountJV || 0;
    case 'ro':
      return firma.discountRO || 0;
    case 're':
      return firma.discountRE || 0;
    case 'ug':
      return firma.discountUG || 0;
    case 'pi':
      return firma.discountPI || 0;
    case 'jo':
      return firma.discountJO || 0;
    default:
      return 0;
    }
  };

  switch (currentProduct.cod) {
  case 'jv':
    return {
      ...baseOrder,
      discount: firma.discountJV || 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 'ro':
    return {
      ...baseOrder,
      discount: firma.discountRO || 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 're':
    return {
      ...baseOrder,
      discount: firma.discountRE || 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 'ug':
    return {
      ...baseOrder,
      discount: firma.discountUG || 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 'pi':
    return {
      ...baseOrder,
      discount: firma.discountPI || 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 'jo':
    return {
      ...baseOrder,
      discount: firma.discountJO || 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 'sv':
    return {
      ...baseOrder,
      discount: 0,
      discountComisionar: isComisionar ? getDiscountComisionar() : 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  case 'ex':
    return {
      ...baseOrder,
      discount: 0,
      discountComisionar: 0,
      discountClientFinal: 0,
      valoareComisionar: 0,
    };
  default:
    return null;
  }
};

/**
 * Construiește obiectul currentItem ce va fi folosit la deschiderea ReperEdit,
 * pornind de la datele precompletate din Expozor.
 */
export const buildPrefillItemFromExpo = (expoPayload, currentProduct) => {
  const expo = expoPayload?.expo || {};
  const prefillSource = expo.precompletare
    ? JSON.parse(JSON.stringify(expo.precompletare))
    : {};

  const productTitle = currentProduct?.title
    ? currentProduct.title.toUpperCase()
    : currentProduct?.cod?.toUpperCase() || '';

  const fallbackSubProd = prefillSource.denumireSubProdus
    || expo.Tip
    || productTitle;

  const base = {
    buc: 1,
    tipProdus: currentProduct?.cod || '',
    denumireProdus: productTitle,
    denumireSubProdus: fallbackSubProd,
    observatii: expo.Cod ? `Reper adaugat din expozorul ${expo.Cod}` : '',
  };

  const merged = {
    ...base,
    ...prefillSource,
  };

  // Forțăm unele câmpuri critice să fie aliniate cu produsul curent
  merged.tipProdus = currentProduct?.cod || merged.tipProdus || '';
  if (!merged.denumireProdus) {
    merged.denumireProdus = productTitle;
  }
  if (!merged.denumireSubProdus) {
    merged.denumireSubProdus = fallbackSubProd;
  }
  if (!merged.buc) {
    merged.buc = 1;
  }

  return merged;
};


